import burger from "./modules/burger";
import { accordionDinamic } from "./modules/accordion";
import smoothScroll from "./modules/smooth-scroll";
import learningMaterialsArr from "./data/learningMaterialsArr";
import modal, { openModal } from "./modules/modal";
import forms from "./modules/forms";
import { smartMessengersHandler } from "./modules/smartMessengersHandler";

window.addEventListener('DOMContentLoaded', () => {
    const modalTimerId = setTimeout(() => {
        openModal(
            '.modal',
            modalTimerId,
            undefined,
            true
        );
    }, 120000);

    modal('[data-modal]', '.modal', modalTimerId);
    forms('#form', modalTimerId);

    accordionDinamic(
        learningMaterialsArr,
        '.learning__wrapper',
        '.learning__descr',
        '.learning__btn',
        '.learning__title'
    );
    burger({
        menuSelector: '.header__menu',
        menuItemSelector: '.header__item',
        hamburgerSelector: '.hamburger',
        menuSelectorActive: 'header__menu_active',
        hamburgerSelectorActive: 'hamburger_active'
    });
    smoothScroll('.pageup', 500);
    smartMessengersHandler();
});